import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { InputTime } from '@goodfynd/react-web.forms.input-date-time';
import { useWizard, useWizardData } from '@goodfynd/react-web.lib.forms';
import { dateUtil } from '@goodfynd/react-web.utils.date-util';
import { isSameDay } from 'date-fns';
import some from 'lodash/some';

import InputCalendar from '../../../forms/InputCalendar';
import type { EventTimesFormFields } from '../types';
const EventTimes = ({
  control,
  watch,
}: UseFormReturn<EventTimesFormFields>) => {
  const { isEditing } = useWizard();
  const { dates } = useWizardData<EventTimesFormFields>();

  const startTime = watch('start');
  return (
    <div>
      <InputCalendar
        control={control}
        minDate={new Date()}
        name="dates"
        removeButton={!isEditing}
        mapDays={({ date }) => {
          return {
            disabled:
              isEditing &&
              dates &&
              some(dates, (day) => {
                return isSameDay(day, date.toDate());
              }),
          };
        }}
      />

      <InputTime control={control} label="Start Time" name="start" />

      <InputTime
        control={control}
        label="End time"
        name="end"
        presets={
          startTime
            ? [
                dateUtil.addHours(startTime, 2),
                dateUtil.addHours(startTime, 3),
                dateUtil.addHours(startTime, 4),
                dateUtil.addHours(startTime, 8),
              ]
            : []
        }
      />

      <InputTime
        control={control}
        label="Setup time"
        name="setup"
        presets={
          startTime
            ? [
                dateUtil.addMinutes(startTime, -15),
                dateUtil.addMinutes(startTime, -30),
                dateUtil.addMinutes(startTime, -60),
                dateUtil.addMinutes(startTime, -90),
              ]
            : []
        }
      />
    </div>
  );
};

export default EventTimes;
